import React from 'react';
import { CtaButton } from './CtaButton';
import { checkoutUrl, ctaLabels, offer, offerIncludes } from '../data/content';
export function Pricing() {
  return <section id="planes" className="w-full bg-cream py-14 md:py-24" data-id="element-117" data-mp="2ap7z7c82fmov">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-118" data-mp="2oi7g9inhxoyj">
        <div className="relative mx-auto mt-4 max-w-xl rounded-3xl bg-ivory px-5 pb-8 pt-10 shadow-soft ring-2 ring-wine sm:px-6 md:px-10 md:pb-10" data-id="element-119" data-mp="2jj4b7y7iniqk">
          <p className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap rounded-full bg-wine px-5 py-1.5 text-xs font-bold uppercase tracking-[0.16em] text-white" data-id="element-120" data-mp="1vubl4idks53v">
            {offer.eyebrow}
          </p>

          <header className="text-center" data-id="element-121" data-mp="20teg19zucuy4">
            <h2 className="font-serif text-3xl font-semibold leading-tight text-ink md:text-5xl" data-id="element-122" data-mp="20sd6xb2dyij1">
              {offer.name}
            </h2>
            <p className="mx-auto mt-3 max-w-sm text-muted md:text-lg" data-id="element-123" data-mp="3h97jhre06op5">{offer.subtitle}</p>
          </header>

          <ul className="mt-7 divide-y divide-line border-y border-line" data-id="element-124" data-mp="3vzp6pldb6gal">
            {offerIncludes.map(item => <li key={item.label} className="flex items-center gap-3 py-3.5" data-id="element-125" data-mp="4scod30ovwt3">
                <span className="text-xl" aria-hidden="true" data-id="element-126" data-mp="9si8ly4mqh15">
                  {item.emoji}
                </span>
                <span className="font-medium text-ink" data-id="element-127" data-mp="erv2h2tx4od8">{item.label}</span>
              </li>)}
          </ul>

          <div className="mt-7 text-center" data-id="element-128" data-mp="3daa61s1jbt6q">
            <p className="text-muted" data-id="element-129" data-mp="3d74jokkaj5ep">
              Precio regular{' '}
              <span className="font-semibold line-through decoration-gold decoration-2" data-id="element-130" data-mp="3i8bpwf6sbwj9">
                {offer.listPrice}
              </span>
            </p>
            <p className="mt-4 text-xs font-bold uppercase tracking-[0.2em] text-wine" data-id="element-131" data-mp="3ry3lncqmevpb">Hoy</p>
            <p className="mt-2 font-serif text-6xl font-semibold leading-none text-wine md:text-8xl" data-id="element-132" data-mp="2uizf5avt7geu">
              {offer.price}
            </p>
            <p className="mt-3 text-sm font-semibold text-muted" data-id="element-133" data-mp="2zfpz49aqiw5j">Pago único</p>
          </div>

          <div className="mt-8" data-id="element-134" data-mp="2rf1stxn5xa57">
            <CtaButton size="lg" className="w-full" href={checkoutUrl} data-id="element-135" data-mp="2mhrtnq9z1k46">
              {ctaLabels.primary}
            </CtaButton>
            <p className="mt-4 text-center text-sm text-muted" data-id="element-136" data-mp="316xshd4wd8bj">
              Acceso inmediato · Formato digital · Acceso de por vida
            </p>
          </div>
        </div>
      </div>
    </section>;
}